import { ref } from "vue";

export const cp_bg_c_cart_2025_02_03 = ref({ user_details: {}, meta_data: {} })